(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('EditModalPreApprovedController', EditModalPreApprovedController)

    EditModalPreApprovedController.$inject = ['$uibModalInstance', 'preApprovedItem', 'sellers', 'VirtualFairService', '$rootScope'];

    function EditModalPreApprovedController($uibModalInstance, preApprovedItem, sellers, VirtualFairService, $rootScope) {
        var vm = this;

        vm.preApprovedItem = preApprovedItem;
        vm.sellers         = sellers;
        vm.seller          = '';
        vm.registered      = '';
        vm.query           = [];
        vm.ok              = ok;
        vm.cancel          = cancel;
        vm.update          = update;

        activate();

        function activate() {
            vm.seller = {id:vm.preApprovedItem.seller_id, name:vm.preApprovedItem.seller_name};
            vm.registered = preApprovedItem.registered;
        }

        function ok () {
            $uibModalInstance.close();
        }

        function cancel () {
            $uibModalInstance.close();
        }

        function update() {
            vm.query['registered']          = vm.registered;

            if($rootScope.can('view_virtual_fair_representative'))
            vm.query['seller']              = vm.seller.id;
            vm.query['observation']         = vm.preApprovedItem.admin_observation;
            vm.query['pre_register_cod']    = vm.preApprovedItem.id;

            VirtualFairService.updatePreApproved(vm.query).then(function(response){
                alertify.notify(response.data, 'success', 3);
                vm.preApprovedItem.seller_name = vm.seller.name;

            }).catch(function(err) {
                alertify.notify(err, 'danger', 3);
            });
        }

    }

})();